// Gallery.js
import React, { useState } from 'react';
import './Gallery.css';
import img1 from './images/gallery1.jpg'
import img2 from './images/gallery2.jpg'
import img3 from './images/gallery3.jpg'
import img4 from './images/gallery4.jpg'
import img5 from './images/gallery5.jpg'
import img6 from './images/gallery6.jpg'
import img7 from './images/gallery7.jpg'

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  
  // Sample image data (replace with your actual images)
  const images = [
    { id: 1, src: img1, alt: '' },
    { id: 2, src: img2, alt: '' },
    { id: 3, src: img3, alt: '' },
    { id: 4, src: img4, alt: '' },
    { id: 5, src: img5, alt: '' },
    { id: 6, src: img6, alt: '' },
    { id: 7, src: img7, alt: '' },
    // { id: 8, src: '', alt: 'Image 8' },
    // { id: 9, src: '', alt: 'Image 9' },
    // { id: 10, src: '', alt: 'Image 10' },
    // { id: 11, src: '', alt: 'Image 11' },
  ];

  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <div className="gallery-container">
      <h1 className="gallery-title">Image Gallery</h1>
      <p className="gallery-description">Beautiful collection of photographs</p>
      
      <div className="gallery-grid">
        {images.map((image) => (
          <div 
            key={image.id} 
            className="gallery-item"
            onClick={() => openModal(image)}
          >
            <img 
              src={image.src} 
              alt={image.alt}
              className="gallery-image"
              loading="lazy"
            />
            <div className="image-overlay">
              <div className="image-text">{image.alt}</div>
            </div>
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="modal" onClick={closeModal}>
          <span className="close-button" onClick={closeModal}>&times;</span>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img 
              src={selectedImage.src} 
              alt={selectedImage.alt}
              className="modal-image"
            />
            <div className="modal-text">{selectedImage.alt}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;